import { render } from "./ArticleRow.vue?vue&type=template&id=17f78618&scoped=true"
import script from "./ArticleRow.vue?vue&type=script&lang=js"
export * from "./ArticleRow.vue?vue&type=script&lang=js"

import "./ArticleRow.vue?vue&type=style&index=0&id=17f78618&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f78618"]])

export default __exports__